import Vue from 'vue'
import Router from 'vue-router'
import LoginForm from '@/components/LoginForm'
import ResetPasswordForm from '@/components/ResetPasswordForm'
import KycAdmin from '@/components/KycAdmin'
import KycDetails from '@/components/KycDetails'
import Reports from '@/components/Reports'
import AdminPage from '@/components/AdminPage'
import Status404 from '@/components/Status404'
import KycForm from '@/components/KycForm/KycForm'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: KycAdmin,
      meta: {
        auth: true,
        redirect: '/',
        title: 'KYC'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginForm,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPasswordForm,
      meta: {
        title: 'Reset Password'
      }      
    },
    {
      path: '/kyc/:kycId',
      name: 'details',
      component: KycDetails,
      meta: {
        auth: true,
        redirect: '/',
        title: 'Reset Password' 
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        auth: true,
        redirect: '/',
        title: 'Reports'
      }
    },
    {
      path: '/new',
      name: 'new',
      component: KycForm,
      meta: {
        auth: true,
        redirect: '/',
        title: 'New KYC Form'
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminPage,
      meta: {
        auth: ['superadmin'],
        redirect: '/',
        title: 'Admin'
      }
    },
    {
      path: '*',
      component: Status404
    }
  ]
})
